import { render, staticRenderFns } from "./DragableCard.vue?vue&type=template&id=7489ab1e&scoped=true&"
import script from "./DragableCard.vue?vue&type=script&lang=js&"
export * from "./DragableCard.vue?vue&type=script&lang=js&"
import style0 from "./DragableCard.vue?vue&type=style&index=0&id=7489ab1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7489ab1e",
  null
  
)

export default component.exports